<template>
  <div>
    <div class="pb-5">
      <div class="inner-title col">1. Major Customers</div>
      <div class="table-wrapper-scroll-y my-custom-scrollbar">
        <table class="table table-striped mb-0">
          <thead>
            <tr>
              <th scope="col">Sl No</th>
              <th scope="col">Customer Name</th>
              <th scope="col">Years in Partnership</th>
              <th scope="col">Approx Revenue(INR-Lakhs)</th>
              <th scope="col">References</th>
            </tr>
          </thead>
          <tbody class="text-left">
            <tr v-for="(customer,index) in partnershipAvenue.customers" :key="index">
              <td scope="col">{{index+1}}</td>
              <td scope="col">{{customer.customerName}}</td>
              <td scope="col">{{customer.yearsInPartnership}}</td>
              <td scope="col">{{customer.revenuePercentage}}</td>
              <td scope="col">{{customer.references}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="pb-5">
      <div class="inner-title col">2. Projects</div>
      <div class="table-wrapper-scroll-y my-custom-scrollbar">
        <table class="table table-striped mb-0">
          <thead>
            <tr>
              <th scope="col">Sl No</th>
              <th scope="col">Type</th>
              <th scope="col">Origin</th>
              <th scope="col">Country</th>
              <th scope="col">Location</th>
              <th scope="col">Name</th>
              <th scope="col">Project(Duration)</th>
              <!-- <th scope="col">Currency</th> -->
              <th scope="col">Value(INR)</th>
              <th scope="col">Key Features</th>
              <th scope="col">Customer</th>
            </tr>
          </thead>
          <tbody class="text-left">
            <tr v-for="(project,index) in partnershipAvenue.projects" :key="index">
              <td scope="col">{{index+1}}</td>
              <td scope="col">{{project.projectType}}</td>
              <td scope="col">{{project.origin}}</td>
              <td scope="col">{{project.country}}</td>
              <td scope="col">{{project.location}}</td>
              <td scope="col">{{project.projectName}}</td>
              <td scope="col">{{project.projectPeriod}}</td>
              <!-- <td scope="col">{{project.currency}}</td> -->
              <td scope="col">{{project.projectValue}}</td>
              <td scope="col">{{project.keyFeatures}}</td>
              <td scope="col">{{project.customerName}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="pb-5">
      <div class="inner-title col">3. Key Suppliers/Sub Contractors</div>
      <div class="table-wrapper-scroll-y my-custom-scrollbar">
        <table class="table table-striped mb-0">
          <thead>
            <tr>
              <th scope="col">Sl No</th>
              <th scope="col">Partner Type</th>
              <th scope="col">Partner Details</th>
            </tr>
          </thead>
          <tbody class="text-left">
            <tr v-for="(subdivision,index) in partnershipAvenue.subdivisions" :key="index">
              <td scope="col">{{index+1}}</td>
              <td scope="col">{{subdivision.partnerType}}</td>
              <td scope="col">{{subdivision.partnerDetails}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="pt-2" v-if="!branchLogIn">
      <div class="inner-title col" v-if="partnershipAvenue.documentId">4. Your Business Struture</div>
      <div class="row" v-if="partnershipAvenue.documentId">
        <div class="col-sm">Document</div>
        <div class="col-sm">
          <span
            v-if="partnershipAvenue.documentId == '' || partnershipAvenue.documentId == 'Not Yet Attached'"
          >{{partnershipAvenue.documentId}}</span>
          <span v-else>
            <a
              @click="showFile(partnershipAvenue.documentId)"
              href="#"
            >{{getAttachmentName(partnershipAvenue.documentId)}}</a>
          </span>
        </div>
      </div>
    </div>
    <w-loadingSpinner :loadSpinner="loading" />
  </div>
</template>
<script>
import { PartnerService } from "../../services/partnerService";
import loadingSpinner from "../../widgets/LoadingSpinner";
const partnerService = new PartnerService();
export default {
  props: ["partnershipAvenue", "branchLogIn"],
  components: {
    "w-loadingSpinner": loadingSpinner
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    showFile(documentId) {
      this.loading = true;
      partnerService
        .downLoadDocument(documentId)
        .then(res => {
          this.loading = false;
          // alert("Downlodeded1");
        })
        .catch(e => {});
    },
    getAttachmentName(documentId) {
      let attachmentName = "";
      attachmentName = documentId.split(/_(.+)/)[1]
        ? documentId.split(/_(.+)/)[1]
        : documentId;
      return attachmentName;
    }
  }
};
</script>
<style scoped>
.inner-title {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
  text-align: left;
  font-stretch: normal;
  line-height: 1.25;
  text-align: left;
  padding-bottom: 1%;

  /* width: 246px;
  height: 36px;
  font-family: SourceSansProSemiBold;
  font-size: 14px;
  font-weight: 700;
  font-style: normal;
  font-stretch: normal;
  line-height: 3.06;
  letter-spacing: 0.16px;
  text-align: left;
  color: #212121; */
  /* font-family: "Source Sans Pro", sans-serif;
  font-weight: bold;
  font-size: 13px; */
}
.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #d0d3d6;
  background-color: #6192b1;
  position: sticky;
  color: #fff;
  text-align: left;
}
.my-custom-scrollbar {
  /* position: relative; */
  /* height: 150px; */
  max-height: 300px;
  width: 100%;
  overflow: auto;
  font-family: "Source Sans Pro", sans-serif;
}
</style>